// ACTIVITY
export const ACTIVITY = '/activity';
export const GET_ACTIVITIES = '/activity/';
export const GET_ACTIVITIES_QUERY = '/activity/query';
export const DELETE_ACTIVITY = '/activity';
export const ADD_ACTIVITY = '/activity/';
export const UPDATE_ACTIVITY = '/activity';
export const GET_ACTUAL_ACTIVITIES = '/activity/actual';

// ACTIVITY GROUP
export const ACTIVITY_GROUP = '/activity_group';
export const GET_ACTIVITY_GROUPS = '/activity_group/';
export const GET_ACTIVITY_GROUP_BY_CODE = '/activity_group/code';
export const DELETE_ACTIVITY_GROUP = '/activity_group';
export const ADD_ACTIVITY_GROUP = '/activity_group/';
export const UPDATE_ACTIVITY_GROUP = '/activity_group';

// ACTIVITY PERIODICITY
export const ACTIVITY_PERIODICITY = '/activity_periodicity';
export const GET_ACTIVITY_PERIODICITIES = '/activity_periodicity/';
export const GET_ACTIVITY_PERIODICITY_BY_CODE = '/activity_periodicity/code';
export const DELETE_ACTIVITY_PERIODICITY = '/activity_periodicity';
export const ADD_ACTIVITY_PERIODICITY = '/activity_periodicity/';
export const UPDATE_ACTIVITY_PERIODICITY = '/activity_periodicity';

// ACTIVITY PRIORITY
export const ACTIVITY_PRIORITY = '/activity_priority';
export const GET_ACTIVITY_PRIORITIES = '/activity_priority/';
export const GET_ACTIVITY_PRIORITY_BY_CODE = '/activity_priority/code';
export const DELETE_ACTIVITY_PRIORITY = '/activity_priority';
export const ADD_ACTIVITY_PRIORITY = '/activity_priority/';
export const UPDATE_ACTIVITY_PRIORITY = '/activity_priority';

// ACTIVITY STATUS
export const ACTIVITY_STATUS = '/activity_status';
export const GET_ACTIVITY_STATUSES = '/activity_status/';
export const GET_ACTIVITY_STATUS_BY_CODE = '/activity_status/code';
export const DELETE_ACTIVITY_STATUS = '/activity_status';
export const ADD_ACTIVITY_STATUS = '/activity_status/';
export const UPDATE_ACTIVITY_STATUS = '/activity_status';

// ACTIVITY TYPE
export const ACTIVITY_TYPE = '/activity_type';
export const GET_ACTIVITY_TYPES = '/activity_type/';
export const GET_ACTIVITY_TYPE_BY_CODE = '/activity_type/code';
export const DELETE_ACTIVITY_TYPE = '/activity_type';
export const ADD_ACTIVITY_TYPE = '/activity_type/';
export const UPDATE_ACTIVITY_TYPE = '/activity_type';

// ACTIVITY TEMPLATE
export const ACTIVITY_TEMPLATE = '/activity_template';
export const ACTIVITY_TEMPLATE_CODE = '/activity_template/code';
export const GET_ACTIVITY_TEMPLATES = '/activity_template/';
export const DELETE_ACTIVITY_TEMPLATE = '/activity_template';
export const ADD_ACTIVITY_TEMPLATE = '/activity_template/';
export const UPDATE_ACTIVITY_TEMPLATE = '/activity_template';

// ACTIVITY TEMPLATE ITEM
export const ACTIVITY_TEMPLATE_ITEM = '/activity_template_item';
export const GET_ACTIVITY_TEMPLATE_ITEMS = '/activity_template_item/';
export const DELETE_ACTIVITY_TEMPLATE_ITEM = '/activity_template_item';
export const ADD_ACTIVITY_TEMPLATE_ITEM = '/activity_template_item/';
export const UPDATE_ACTIVITY_TEMPLATE_ITEM = '/activity_template_item';
